import { h } from "snabbdom";
import type { VNode } from "snabbdom";
import type { Model, Msg } from "../types";
import { viewMetadata } from "./metadata";
import { viewBacklinks } from "./backlinks";
import { mountEditor } from "../editor";
import { UNREADABLE_TEXT } from "../editor/cards";

export function viewCard(model: Model, dispatch: (msg: Msg) => void): VNode {
  const id = model.currentCardId!;
  const card = model.cardCache[id];
  const editorState = model.editorStates[id];
  const unreadable = model.unreadableCards[id];

  if (!card || (!editorState && unreadable === undefined)) {
    return h("div.card-loading", "Loading…");
  }

  const isHome = model.homeCardId === id;

  return h("article.card", [
    h("div.card-actions", [
      h(
        "button.card-actions__btn" + (isHome ? ".card-actions__btn--active" : ""),
        {
          attrs: { type: "button", title: isHome ? "Home card (click to unset)" : "Set as home card" },
          on: { click: () => dispatch({ type: "ToggleHomeCard", id }) },
        },
        "⌂"
      ),
      h(
        "button.card-actions__btn.card-actions__btn--delete",
        {
          attrs: { type: "button", title: "Delete card" },
          on: { click: () => dispatch({ type: "RequestDeleteCard", id }) },
        },
        "🗑"
      ),
    ]),
    viewMetadata(model, card, dispatch),
    viewBacklinks(card, model.cardCache, dispatch),
    unreadable === undefined ? mountEditor(card, dispatch) : viewUnreadable(unreadable),
  ]);
}

function viewUnreadable(reason: string): VNode {
  return h("div.card-unreadable", [h("p", UNREADABLE_TEXT), h("code", reason)]);
}
